import { Component } from '@angular/core';

@Component({
  selector: 'app-user-affiliate-info-modal',
  templateUrl: './user-affiliate-info-modal.component.html',
  styleUrls: ['./user-affiliate-info-modal.component.scss']
})
export class UserAffiliateInfoModalComponent {

}
